import { toast } from "sonner";
import { CopyIcon, XLogoIcon, ListNumbersIcon } from "@phosphor-icons/react";

export default function StoryThread({ tweets = [] }) {
  if (!tweets.length) return null;
  const total = tweets.length;

  const copyOne = (t) => navigator.clipboard.writeText(t).then(() => toast.success("Tweet copied")).catch(() => toast.error("Copy failed"));
  const copyAll = () => {
    const joined = tweets.map((t, i) => `${i + 1}/${total} ${t}`).join("\n\n");
    navigator.clipboard.writeText(joined).then(() => toast.success("Whole thread copied")).catch(() => toast.error("Copy failed"));
  };
  const postOne = (t, i) => {
    const text = i === 0 ? t : `${i + 1}/${total} ${t}`;
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="mt-2" data-testid="story-thread">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <ListNumbersIcon size={16} weight="fill" className="text-neon" />
          <h4 className="font-heading font-bold text-sm tracking-tight">X Thread · {total} tweets</h4>
        </div>
        <button data-testid="thread-copy-all-btn" onClick={copyAll} className="flex items-center gap-1.5 px-3 py-1.5 text-xs border border-white/15 hover:border-neon/40 hover:text-neon transition-colors">
          <CopyIcon size={14} /> Copy whole thread
        </button>
      </div>
      <div className="space-y-2.5">
        {tweets.map((t, i) => {
          const over = t.length > 280;
          return (
            <div key={i} className="border border-white/10 bg-black/30 p-3" data-testid={`thread-tweet-${i}`}>
              <div className="flex items-start gap-2.5">
                <span className="font-mono text-[11px] text-neon shrink-0 mt-0.5">{i + 1}/{total}</span>
                <p className="text-sm text-white/90 leading-relaxed flex-1 whitespace-pre-wrap">{t}</p>
              </div>
              <div className="flex items-center justify-between gap-2 mt-2 pt-2 border-t border-white/5">
                <span className={`font-mono text-[10px] ${over ? "text-red-400" : "text-muted-foreground"}`}>{t.length}/280{over ? " · too long" : ""}</span>
                <div className="flex items-center gap-2">
                  <button data-testid={`thread-copy-${i}`} onClick={() => copyOne(t)} className="flex items-center gap-1 px-2 py-1 text-[11px] border border-white/12 hover:border-neon/40 hover:text-neon transition-colors">
                    <CopyIcon size={12} /> Copy
                  </button>
                  <button data-testid={`thread-post-${i}`} onClick={() => postOne(t, i)} className="flex items-center gap-1 px-2 py-1 text-[11px] font-semibold bg-neon/90 text-black hover:bg-neon transition-colors">
                    <XLogoIcon size={12} weight="fill" /> Post
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
